export default {
      id: "A-usage",
      viewBox: "0 0 400 490",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#A-usage",
      toString: function () {
        return this.url;
      }
    }